<div class="store-not-found">
  <span class="mascot-container">
    <img class="mascot" src="assets/mascot/Mascot_sorry-Grey@2x.webp" alt="odaring mascot">
  </span>
  <p class="not-found-description">{{"merchant.search.no.result" | translate}}</p>

  <button class="back-button" (click)="goBackToPreviousPage()">{{"button.back" | translate}}</button>
</div>
